import React from "react";
import { connect } from "react-redux";
import DashboardActionBar from "../../DashboardActionBar";
import Modal from "../../Modal";
import Loading from "../../Loading";
import { ajaxFeedbackStatusFilter, getStarsJSX, setFeedbackStatus, setLoading } from "../../redux/FeedbackRedux";
import FilterBar from "../../v2/FilterBar";
import FeedbackInbox from "../../v2/FeedbackInbox";
import SearchBar from "../../SearchBar";
import SmartTableGrid from "../../SmartTableGrid";

class AdminDashboard extends React.Component {

    constructor(props) {
        super(props);

        props.dispatch(ajaxFeedbackStatusFilter(props.state, "All", null, null, null, true));
        props.dispatch(setFeedbackStatus("All"));

        this.state = {
            apiStatistics: [],
            apiDataTotals: [],
            paginationData: {},
            loading: true,
            timeframe: this.props.state.timeframe
        };

        this.fetchTotalsData = this.fetchTotalsData.bind(this);
        this.fetchStatisticsData = this.fetchStatisticsData.bind(this);
        this.handleTimeframeChange = this.handleTimeframeChange.bind(this);
    }

    fetchStatisticsData = (timeframe, startDate = false, endDate = false) => {
        this.props.dispatch(setLoading({ loading: true, location: "stats" }));
        fetch(`/feedback-dashboard/statistics`, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": $("meta[name=\"csrf-token\"]").attr("content"),
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify({
                timeframe: timeframe
            })
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ apiStatistics: data, loading: false });
                this.props.dispatch(setLoading({ loading: false, location: "stats" }));
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                this.setState({ loading: false });
                this.props.dispatch(setLoading({ loading: false, location: "stats" }));
            });
    };

    fetchTotalsData = (timeframe, startDate = false, endDate = false) => {
        // Base URL
        let url = `/feedback-dashboard/totals?timeframe=${timeframe}`;

        // Append startDate and endDate if they are provided
        if (startDate && endDate) {
            url += `&date_from=${startDate}&date_to=${endDate}`;
        } else if (startDate) {
            url += `&date_from=${startDate}`;
        } else if (endDate) {
            url += `&date_to=${endDate}`;
        }
        this.props.dispatch(setLoading({ loading: true, location: "stats" }));

        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ apiDataTotals: data, loading: false });
                this.props.dispatch(setLoading({ loading: false, location: "stats" }));
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                this.setState({ loading: false });
                this.props.dispatch(setLoading({ loading: false, location: "stats" }));
            });
    };

    componentDidMount() {
        if (window && window.localStorage.getItem("timeframe")) {
            this.setState({ timeframe: window.localStorage.getItem("timeframe") });
        }

        if (this.props.state.timeframe === "custom") {
            const startDate = window.localStorage.getItem("prev_date");
            const endDate = window.localStorage.getItem("next_date");
            this.fetchStatisticsData(this.props.state.timeframe, startDate, endDate);
            this.fetchTotalsData(this.props.state.timeframe, startDate, endDate);
        } else {
            this.fetchStatisticsData(this.props.state.timeframe);
            this.fetchTotalsData(this.props.state.timeframe);
        }
    }

    handleTimeframeChange(newTimeframe) {
        this.setState({ timeframe: newTimeframe });
        if (newTimeframe !== "custom") {
            this.fetchStatisticsData(newTimeframe);
            this.fetchTotalsData(newTimeframe);
        } else {
            // get custom dates
            const startDate = window.localStorage.getItem("prev_date");
            const endDate = window.localStorage.getItem("next_date");
            this.fetchStatisticsData(newTimeframe, startDate, endDate);
            this.fetchTotalsData(newTimeframe, startDate, endDate);
        }
    }

    getColumns = () => {
        const feedbackStatuses = window.feedbackStatus;
        const timeframe = this.props.state.timeframe;

        const generateFeedbacksURL = (base_url, feedbackStatus, chats = null) => {
            let others = chats ? chats : this.props.other;
            let url = `${base_url}/timeframe/${timeframe}/status/${feedbackStatus}/other/${others}`;
            if (feedbackStatuses.RatingsOnly.value === feedbackStatus) {
                url += `?filterRating=1,2,3,4,5`;
            }
            return { feedbacksUrl: url };
        };

        const calcAIScore = (value) => {
            let score;
            if (value !== undefined) {
                score = value < 50
                    ? "text-danger"
                    : value < 65
                        ? "text-warning"
                        : "text-success";
            }
            return score;
        };

        return [
            {
                width: "20%",
                key: "businessName",
                label: __("Location"),
                sortable: true,
                defaultSort: "asc",
                searchable: true,
                sortValue: row => row.businessName || "",
                render: (value, row) => row.isTotalRow
                    ? <strong>{row.totalBusinesses} {__("Locations")}</strong>
                    : <a href={`/business/${row.business_id}/feedbacks?${this.props.state.openStatusUrl}`}>{value}</a>
            },
            ...["All", "Open", "Pending", "Resolved", "RatingsOnly"].map(statusKey => ({
                width: "8%",
                key: statusKey === "All" ? "totalFeedbacksWithoutRatingsOnly" : statusKey,
                label: statusKey === "All" ? "Feedbacks" : feedbackStatuses[statusKey]?.label || statusKey,
                sortable: true,
                render: (value, row) => {
                    if (row.isTotalRow) return <strong>{value}</strong>;
                    const url = generateFeedbacksURL(`/business/${row.business_id}/feedbacks`, feedbackStatuses[statusKey].value);
                    return value > 0 ? <a href={url.feedbacksUrl} target="_blank">{value}</a> : 0;
                }
            })),
            {
                width: "8%",
                key: "chatsRequested",
                label: __("Chats Requested"),
                sortable: true
            },
            {
                width: "8%",
                key: "chatsStarted",
                label: __("Chats Started"),
                sortable: true
            },
            {
                width: "8%",
                key: "sentimentScore",
                label: (
                    <span>
                        {__("AI Sentiment Score")}
                        <i
                            className="far fa-question-circle text-muted ml-1"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-title={__("Feedback uses Artificial Intelligence to automatically scan Feedbacks to assess your customers' positive and negative language and emotions. The AI Sentiment Score is graded on a scale of 0% (very negative) to 100% (very positive).")}
                        ></i>
                    </span>
                ),
                sortable: true,
                sortValue: row => row.sentimentScore || "",
                render: (value, row) => {
                    return <div className={calcAIScore(value) + " col-1"}>
                        {value ? value + "%" : __("No Data")}
                    </div>;
                }
            },
            {
                width: "8%",
                key: "medianResponseTime.formatted",
                label: __("Median Resp Time"),
                sortable: true,
                sortValue: row => row.medianResponseTime.seconds || "",
                render: value => value || __("No data")
            },
            {
                width: "8%",
                key: "averageRating",
                label: __("Ratings"),
                sortable: true,
                sortValue: row => row.averageRating || "",
                render: (value, row) => {
                    if (row.isTotalRow) return <strong>{parseFloat(value).toFixed(2)}</strong>;
                    return value > 0 ? (
                        <div>
                            <span className="mr-1 d-block">{parseFloat(value).toFixed(2)}</span>
                            <span className="font-10px">{getStarsJSX(value, "OTF", true)}</span>
                        </div>
                    ) : __("No data");
                }
            }
        ];
    };


    render() {
        const { apiStatistics, apiDataTotals, loading } = this.state;

        if (loading) {
            return <Loading location={"page"} />;
        }

        return (
            <div className="container-fluid dashboard-container">
                <Loading location={"page"} />
                <div className="row dashboard-stats sortable-table">
                    <DashboardActionBar onTimeframeChange={this.handleTimeframeChange} hideExport={false}
                                        excludeStatistics={true} doDispatch={true} />

                    <SmartTableGrid
                        data={apiStatistics}
                        totalsRow={apiDataTotals}
                        columns={this.getColumns()}
                        enableSearch={true}
                        enablePagination={true}
                        enableItemsPerPage={true}
                    />
                </div>

                <SearchBar title="All Open Feedbacks" searchType="standard" excludeStatistics={true} />
                <FilterBar excludeStatistics={true} />
                <FeedbackInbox />
                <FilterBar position="bottom" excludeStatistics={true} />

                <Modal modal={this.props.state.modal} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state };
}

export default connect(mapStateToProps)(AdminDashboard);
